<!-- Product description -->
<div class="py-6">
  <h5 class="text-zestBlack py-2 font-medium">Product Description</h5>
  <p class="text-zestGrey text-sm">
    {{ productDescription }}
  </p>
</div>

<hr class="border-[#C1C7D0]" />

<div class="flex flex-col gap-6 pt-6">
  <!-- Delivery -->
  <div>
    <h5 class="font-semibold text-zestBlack text-sm pb-2">Delivery:</h5>
    <p class="font-normal text-sm leading-6 text-zestBlack" *ngIf="delivery">
      Estimated between
      {{ delivery }} after making purchase.
    </p>
  </div>

  <!-- Return policy -->
  <div>
    <h5 class="font-semibold text-zestBlack text-sm pb-2">Return Policy:</h5>
    <p class="font-normal text-sm leading-6 text-zestBlack">
      {{ returnPolicy }}
    </p>
  </div>

  <!-- Share this product -->
  <div>
    <h5 class="font-semibold text-zestBlack text-sm">SHARE THIS PRODUCT</h5>
    <div class="flex justify-start items-center py-4">
      <div class="mr-6">
        <button
          shareButton="facebook"
          class="w-8 h-8 cursor-pointer"
          [attr.url]="shareLink"
          [attr.description]="shareDescription"
        >
          <img
            src="../../../assets/svg/facebook.svg"
            alt="close"
            class="w-8 h-8"
          />
        </button>
      </div>
      <div class="mr-6">
        <button
          shareButton="twitter"
          [attr.url]="shareLink"
          [attr.description]="shareDescription"
          class="w-8 h-8 cursor-pointer"
        >
          <img
            src="../../../assets/svg/twitter.svg"
            alt="close"
            class="w-8 h-8"
          />
        </button>
      </div>
      <div class="mr-6">
        <button
          shareButton="whatsapp"
          class="w-8 h-8 cursor-pointer"
          [attr.url]="shareLink"
          [attr.description]="shareDescription"
        >
          <img
            src="../../../assets/svg/whatsapp.svg"
            alt="close"
            class="w-8 h-8 cursor-pointer"
          />
        </button>
      </div>
    </div>
  </div>
</div>
